export const QA_NAME_DOCUMENT_MARK_AS_INVOICE_CONFIRM_MODAL =
  'documentMarkAsInvoiceConfirm'
